<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo_libro.jpeg"
  style="background-image: url('assets/img/fondo_libro.jpeg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
        <div class="col-md-12 logo_gerencia">
            <img src="/assets/img/logo_grd.png" alt="" class="logo_gerencia_imagen" style="width: 150px;">
        </div>
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white">
          <h3 style="color: white">
            <span class="textodelgado"> Proyecto de Creación del Servicio de</span><br>
            <span class="textogordo">GESTIÓN DE RIESGO DE DESASTRES</span> <br>
            <span class="textodelgado"> del Centro Histórico del Cusco</span>
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-10 m-auto text-center">
        <div class="section-title-wrap">
          <h2>“Cusco, de la Catastrofe a la Resiliencia" </h2>
          <p class="mb-0" style="font-weight: 300;">
            La Municipalidad Provincial del Cusco, a través de la Gerencia del
            Centro Histórico, ha asumido un compromiso visionario con el
            proyecto de inversión pública denominado "Creación del Servicio
            de Gestión del Riesgo de Desastres en el Centro Histórico del
            Cusco, del distrito, provincia y departamento del Cusco", cuyo
            propósito es preservar la integridad de sus habitantes, proteger
            las áreas históricas y enfrentar los riesgos emergentes asociados
            a desastres.
          </p>
          <br>
          <p  class="mb-0" style="font-weight: 300;">
            Este libro es uno de los entregables del proyecto en
            ejecución y busca tanto iniciar los estudios sobre Gestión del
            Riesgo de Desastres como dar a conocerlos con la ciudadania.
            El presente libro se adentra en la historia de Cusco durante
            los periodos inca, virreinal y republicano, explorando cómo sus
            habitantes han enfrentado los peligros y fenómenos adversos
            a lo largo del tiempo. A través de un enfoque metodológico
            basado en diversos archivos, esta investigación no solo
            ilumina el pasado, sino que también aporta herramientas
            para una gestión contemporánea más eficiente y consciente.
            Este libro se alinea con ese esfuerzo, situando al Cusco como un
            referente global en la integración de la memoria histórica y la
            gestión de riesgos, mostrando que una ciudad segura es posible
            cuando pasado y futuro dialogan de manera armónica.
          </p>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="page-wrapper"
  style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mb-80 mb-md-80 mb-sm-50">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <iframe style="width:100%;height:700px" src="https://online.anyflip.com/zdbmc/bhar/index.html"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
.logo_gerencia_imagen{
    width: 150px !important;
}
.logo_gerencia{
    display: flex; 
    flex-direction: row; 
    justify-content: center; 
    width: 100px !important; 
    margin-top: 180px !important;
}
.textodelgado{
    font-weight: 100 !important;
    font-size: 25px;
}

.textogordo{
    font-weight: bolder !important;
    font-size: 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991.98px), only screen and (max-width: 767.98px){
    .about-us-content {
            font-size: 14px;
            padding: 0px;
    }
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100px !important;
        margin-top: 250px !important;
        margin-bottom: -100px;
    }
}

@media (max-width: 425px){
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100% !important;
        margin-top: 140px !important;
        margin-bottom: 0px;
    }
    .logo_gerencia_imagen{
        width: 100px !important;
    }
    .textodelgado{
        font-weight: 100 !important;
        font-size: 17px;
    }
    .textogordo{
        font-weight: bolder !important;
        font-size: 17px;
    }
}
</style>